export const IConstructionTypeTypes = {
  CONSTRUCTION: "CONSTRUCTION",
  RECONSTRUCTION: "RECONSTRUCTION",
  RENOVATION: "RENOVATION",
} as const;

export type IConstructionType = (typeof IConstructionTypeTypes)[keyof typeof IConstructionTypeTypes];
